import React, { useContext, useEffect, useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { SettingsContext } from '../../../utils/context'
import { getKioskData, getKioskVideoData, updateKioskVideo, uploadKioskVideo, deleteKioskVideo } from '../../../actions/settings/kiosk'
import { Input, Select } from '../../../components/ModalInputs'
import styles from '../styles.module.scss'
import Table from '../../../components/Table'
import { BiTrash } from 'react-icons/bi'
import Confirmation from '../../../components/Confirmation/Confirmation'
import Modal from 'react-responsive-modal'
import Button from '../../../components/Button'


const SHEDULE_MODES = ['Классический', 'Вертикальный']

export default function Kiosk() {

  const dispatch = useDispatch()
  const { data, video } = useSelector(state => state.settings.kiosk)
  const { form } = useContext(SettingsContext)

  const { values, handleChange, handleBlur, setFieldValue } = form

  const [confirmation, setConfirmation] = useState(false)
  const [modalData, setModalData] = useState(null)
  const [editNpp, setEditNpp] = useState('')
  const fileInputRef = useRef(null)


  useEffect(() => {
    !data && dispatch(getKioskData())
    !video && dispatch(getKioskVideoData())
  }, [])

  const acceptConfirmation = () => {
    if (confirmation?.id) {
      dispatch(deleteKioskVideo(confirmation.id))
    }
    setConfirmation(false)
  }
  const rejectConfirmation = () => {
    setConfirmation(false)
  }

  const openModal = (item) => {
    setModalData(item)
    setEditNpp(item.npp || '')
  }

  const closeModal = () => {
    setModalData(null)
    setEditNpp('')
  }

  const handleSave = () => {
    if (modalData) {
      dispatch(updateKioskVideo({
        id_playlist: modalData.id_playlist,
        npp: editNpp
      }))
      closeModal()
    }
  }

  const handleFileSelect = () => {
    fileInputRef.current?.click()
  }

  const handleFileChange = (e) => {
    const file = e.target.files[0]
    if (file) {
      dispatch(uploadKioskVideo(file))
      closeModal()
    }
    e.target.value = ''
  }

  const renderLi = (item) => {
    const { fname, fsize, id_playlist, npp } = item
    return (
      <tr key={id_playlist} onClick={() => openModal(item)} style={{ cursor: 'pointer' }}>
        <td>{npp}</td>
        <td>{fname}</td>
        <td>{fsize}</td>
        <td>
          <i
            className={styles.trash}
            onClick={(e) => {
              e.stopPropagation()
              setConfirmation({ id: id_playlist, name: fname })
            }}
          >
            <BiTrash />
          </i>
        </td>
      </tr>
    )
  }

  return (
    <div className={styles.resultsWrapper}>
      {confirmation && (
        <Confirmation
          top="30px"
          left="40px"
          title={`Удалить файл "${confirmation.name}"?`}
          confirmation={confirmation}
          acceptConfirmation={() => acceptConfirmation(confirmation)}
          rejectConfirmation={rejectConfirmation}
        />
      )}

      <Modal
        open={!!modalData}
        onClose={() => false}
        showCloseIcon={false}
        center
        classNames={{ modal: styles.kioskModal }}
      >
        <>
          <div className={styles.kioskModalLocal}>
            <h3 className={styles.kioskModalTitle}>Изменение</h3>

            <div className={styles.kioskModalRow}>
              <span className={styles.kioskModalLabel}>Файл</span>
              <span className={styles.kioskModalValue}>{modalData?.fname}</span>
            </div>

            <div className={styles.kioskModalRow}>
              <span className={styles.kioskModalLabel}>Размер (байт)</span>
              <span className={styles.kioskModalValue}>{modalData?.fsize}</span>
            </div>

            <div className={styles.kioskModalRow}>
              <span className={styles.kioskModalLabel}>Порядковый номер</span>
              <input
                type="number"
                className={styles.kioskModalInput}
                value={editNpp}
                onChange={(e) => setEditNpp(e.target.value)}
              />
            </div>
          </div>

          <div className={styles.kioskModalFooter}>
            <input
              type="file"
              ref={fileInputRef}
              style={{ display: 'none' }}
              accept="video/*,.avi,.mp4,.divx,.mpg,.mpeg,.mpv"
              onChange={handleFileChange}
            />
            <Button mode="white" onClick={handleFileSelect}>
              Указать файл
            </Button>
            <Button mode="white" onClick={handleSave}>
              Сохранить
            </Button>
            <Button mode="white" onClick={closeModal}>
              Отмена
            </Button>
          </div>
        </>
      </Modal>

      <div>
        <Select
          label='Режим расписания ДО'
          name='DO_Shedule_Mode'
          value={values.DO_Shedule_Mode}
          onChange={handleChange}
        >
          {SHEDULE_MODES.map(mode => <option key={mode}>{mode}</option>)}
        </Select>
      </div>

      <div>
        <Input
          label='Интервал смены изображений блюд на экране столовой (сек.)'
          name='MenuDelay'
          value={values.MenuDelay}
          onChange={handleChange}
          type='number'
        />
      </div>

      {
        !!video?.length &&
        <div>
          <p>Список видеофайлов: video (avi, mp4, divx, mpg, mpeg, mpv)</p>
          <Table>
            <thead>
              <tr>
                <th>№ п/п</th>
                <th>Файл</th>
                <th>Размер</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {video?.map(renderLi)}
            </tbody>
          </Table>
        </div>
      }

    </div>
  )
}
